import { refreshLinkClickTracking } from "@snowplow/browser-plugin-link-click-tracking";
import { useEffect } from "react";

import { SP_MAIN_TRACKER } from "@src/observability";

export const useUpdateLinkTracking = () => {
  useEffect(() => {
    refreshLinkClickTracking([SP_MAIN_TRACKER]);
  }, []);
};
